import moment from "moment"
import { Avatar } from "../../components/Avatar"
import { Section, SectionWrapper } from "../../components/Section"
import { Tabs } from "../../components/Tabs"
import { BulletTabs } from "../../components/BulletTabs"
import { Spinner } from "../../components/Loading"
import BurnedContainer from "../../container/BurnedContainer"
import ActionPlanContainer from "../../container/ActionPlanContainer"
import IndicatorsContainer from "../../container/IndicatorsContainer"
import NewChatContainer from "../../container/NewChatContainer"
import { AssistancePlanContainer } from "../../container/AssistancePlanContainer"
import { StepRegisterFields } from "../../components/StepFields"
import FormDetailsContainer from "../../container/FormDetailsContainer"
import HeaderBack from "../../components/HeaderBack"
import { Button, ButtonLoader } from "../../components/Button"
import { ExitWithoutSaving } from "../../components/ExitWithoutSaving"
import { FaCircleExclamation } from "react-icons/fa6"
import "./styles.scss"
import { isMobile } from "react-device-detect"
import { ModalPanel } from "../../components/Modal"
import { BsChatText } from "react-icons/bs"
import BeneficiaryEsmContainer from "../../container/GenerateBeneficiaryEsmContainer"

const FarmerProfileScreen = ({
  generalScale,
  noSearchParams,
  values,
  handleActiveIndicator,
  chat,
  steps,
  formSteps,
  handleEdit,
  editedChatFields,
  editIndex,
  handleSave,
  handleCancel,
  loadingField,
  loadingStepsIndicator,
  handleCopy,
  handleChangeChatField,
  onChangeQuestionsInfo,
  tabOptions,
  currentTab,
  setCurrentTab,
  indicatorTabsOptions,
  isSystemChat,
  setIsSystemChat,
  handleSaveFsq,
  formStepsGrouped,
  handleOpenAssistance,
  hasAssistanceId,
  mainCardStatus,
  pageName,
  isScheduleOpen,
  isAssistanceOpen,
  resetFarmerProfile,
  handleGoBack,
  handleOpenFormFill,
  openFormFill,
  hasBackButton,
  handleNavigate,
  allFields,
  onSaveAllItems,
  isModalOpen,
  handleOpenModal,
  handleCloseModal,
  formQuestionMessage,
  setFormQuestionMessage,
  handleOpenGenerateEsmBeneficiary,
  openGenerateEsmBeneficiary,
  reloadQuestionMessage
}) => {

  return (
    <div className="farmer-profile-container">
      <Section className="farmer-section farmer-section__profile">
        {hasBackButton && (
          <HeaderBack title={pageName} handleGoBack={handleGoBack}>
            <div style={{ flex: 1 }} />
            {isMobile || noSearchParams ? (
              <></>
            ) : (
              <>
              <Button
                label="Histórico de Atividades"
                variant="ghost"
                handleClick={handleNavigate}
                classButton={"historico"}
              />
              <BeneficiaryEsmContainer/>
              </>
            )}
            {allFields && allFields.length > 0 && (
              <ButtonLoader
                loading={loadingField}
                messageProcess="Salvando"
                label="Salvar"
                variant="outline"
                handleClick={() => onSaveAllItems()}
              />
            )}
          </HeaderBack>
        )}
        {mainCardStatus?.header && chat?.name && (
          <SectionWrapper className="profile-header">
            <div className="profile-header__user">
              <Avatar size={50} />
              <div className="profile-header__user-details">
                <span className="profile-header__user-details--name">{chat.name}</span>
              </div>
            </div>
          </SectionWrapper>
        )}
        <SectionWrapper className="tabs-header">
          {hasAssistanceId || isAssistanceOpen ? (
            <AssistancePlanContainer
              handleOpenAssistance={handleOpenAssistance}
              currentOpen={hasAssistanceId || isAssistanceOpen}
              onlyForm={isAssistanceOpen || hasAssistanceId === true}
              farmerDetails={chat}
              contextDetails={hasAssistanceId}
              resetFarmerProfile={resetFarmerProfile}
              formQuestionMessage={formQuestionMessage}
              setFormQuestionMessage={setFormQuestionMessage}
            />
          ) : openFormFill ? (
            <FormDetailsContainer
              {...{
                handleOpenFormFill,
                openFormFill,
                showForm: openFormFill,
              }}
            />
          ) : (
            mainCardStatus?.tabs && (
              <Tabs options={tabOptions} value={currentTab} goTo={setCurrentTab}>
                {currentTab.value === 1 ? (
                  <AssistancePlanContainer
                    handleOpenAssistance={handleOpenAssistance}
                    farmerDetails={chat}
                    contextDetails={hasAssistanceId}
                    resetFarmerProfile={resetFarmerProfile}
                    formQuestionMessage={formQuestionMessage}
                    setFormQuestionMessage={setFormQuestionMessage}
                    reloadQuestionMessage={reloadQuestionMessage}
                  />
                ) : currentTab.value === 2 ? (
                  <ActionPlanContainer
                    {...{
                      editedChatFields,
                      values,
                      handleEdit,
                      handleSave,
                      handleCancel,
                      loadingField,
                      onChangeQuestionsInfo,
                      editIndex,
                      formSteps,
                      indicatorTabsOptions,
                      handleActiveIndicator,
                      indicators: formStepsGrouped,
                    }}
                  />
                ) : currentTab.value === 5 ? (
                  <div className="tabs-content profile-content">
                    {steps.length &&
                      steps.map(({ fields }, stepIndex) => {
                        return (
                          <StepRegisterFields
                            {...{
                              fields,
                              editIndex,
                              values,
                              chat,
                              editedChatFields,
                              handleChangeChatField,
                              handleSave,
                              handleEdit,
                              handleCopy,
                              stepIndex,
                              loadingField,
                              handleCancel,
                              currentTab: currentTab.value,
                              allFields,
                            }}
                          />
                        )
                      })}
                  </div>
                ) : currentTab.value === 3 ? (
                  <>
                    {loadingStepsIndicator ? (
                      <div className="loading-tabs-content">
                        <Spinner color="primary" size={40} label="Buscando indicadores..." />
                      </div>
                    ) : (
                      <>
                        <div className="bullet-tabs-sticky">
                          <BulletTabs
                            options={indicatorTabsOptions}
                            onSelect={handleActiveIndicator}
                          />
                        </div>
                        <div className="tabs-content tabs-indicators-container">
                          {allFields && allFields.length > 0 ? (
                            <ExitWithoutSaving
                              text={"Salve as alterações antes de sair da página."}
                              textButton={"Salvar"}
                              icon={<FaCircleExclamation className="icon" />}
                              onSave={() => onSaveAllItems()}
                            />
                          ) : (
                            <div />
                          )}
                          <div className="tabs-indicators-content">
                            <IndicatorsContainer
                              {...{
                                editedChatFields,
                                values,
                                handleEdit,
                                handleSave: handleSaveFsq,
                                handleCancel,
                                handleCopy,
                                loadingField,
                                onChangeQuestionsInfo,
                                editIndex,
                                formSteps,
                                allFields,
                              }}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : currentTab.value === 6 ? (
                  <BurnedContainer onlyMap userInfo={chat} />
                ) : currentTab.value === 4 ? (
                  <FormDetailsContainer
                    {...{
                      handleOpenFormFill,
                      openFormFill,
                    }}
                  />
                ) : (
                  <></>
                )}
              </Tabs>
            )
          )}
          {/* {isScheduleOpen && <SchedulePlanContainer users={[chat]} />} */}
        </SectionWrapper>
      </Section>
      {isMobile ? (
        <></>
      ) : (
        <Section
          className={`farmer-section farmer-section__chat ${isSystemChat ? "system_chat" : ""}`}>
          <Section className="farmer-section__chat-container">
            <NewChatContainer
              changeCurrentChat={(value) => setIsSystemChat(value)}
              defaultChat={chat?.id}
              showOnlyChat
              indicators={formStepsGrouped}
              showActions
              formQuestionMessage={formQuestionMessage}
            />
          </Section>
        </Section>
      )}
      <ModalPanel modalIsOpen={isModalOpen}>
        <Section
          className={`farmer-section farmer-section__chat ${isSystemChat ? "system_chat" : ""}`}>
          <Section className="farmer-section__chat-container">
            <NewChatContainer
              changeCurrentChat={(value) => setIsSystemChat(value)}
              defaultChat={chat?.id}
              showOnlyChat
              indicators={formStepsGrouped}
              showActions
              handleCloseModal={handleCloseModal}
              formQuestionMessage={formQuestionMessage}
            />
          </Section>
        </Section>
      </ModalPanel>
      {isMobile && (
        <div className="chat-button">
          <BsChatText onClick={handleOpenModal} />
        </div>
      )}
    </div>
  )
}

export default FarmerProfileScreen